import { all, put, call, takeEvery } from "redux-saga/effects";
import { DOWNLOAD_EXCEL, SHOW__HIDE_LOADER, DOWNLOAD_ZIP } from '../constants/constants';
import { downloadExcelCall ,downloadZipCall} from '../effects/api/api.report';

function* downloadExcel(data: any) {
  try {
    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const response = yield call(downloadExcelCall, data);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    console.log('downloadExcel', data.payload)
    link.setAttribute('download', data.payload.ModuleName + `${data.payload.ModuleCategoryAbbr} - ` + data.payload.SurveyName + '.xlsx');
    document.body.appendChild(link);
    link.click();
        
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* downloadZip(data:any)
{
  try {
    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const response = yield call(downloadZipCall, data);
    
    const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/zip' }));
    const link = document.createElement('a');
    link.href = url;
    console.log('downloadZip', data.payload)
    link.setAttribute('download',data.payload.SurveyName + '.zip');
    document.body.appendChild(link);
    link.click();
        
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }

}

export const surveyData = (state: any) => state.survey
export default function* SurveySaga() {
  yield all([
    takeEvery(DOWNLOAD_EXCEL, downloadExcel),
    takeEvery(DOWNLOAD_ZIP,downloadZip),
  ])
}




// WEBPACK FOOTER //
// ./src/saga/saga.report.tsx